<template>
<v-container grid-list-lg fluid>
  <v-card tile flat>
    <v-card-title>
      <span class="headline">{{ $t("pageHeader.newGroup") }}</span>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <v-layout class="pa-3" fluid grid-list-lg row wrap>
        <v-flex xs12 sm6="sm6">
          <v-text-field
            v-model.trim="name"
            outline="outline"
            label="Group Name"
            :error-messages="nameErrors"
            @input="$v.name.$touch()"
            required="required"
          >
          </v-text-field>
          <div>
            <v-flex xs12 sm4="sm4">
              <v-text-field
                v-model="code"
                readonly="readonly"
                append-icon="cached"
                @click:append="getCode"
              >
              </v-text-field>
            </v-flex>
          </div>
        </v-flex>
      </v-layout>
    </v-card-text>

    <v-divider> </v-divider>
    <location-list @selectedLocations="selectedLocations" :reload="code"> </location-list>
    <v-card-actions>
      <v-layout justify-end="justify-end" row>
        <v-btn color="info" text @click="close">{{ $t("buttons.cancel") }}</v-btn>
        <v-btn color="info" @click="save">{{ $t("buttons.save") }}</v-btn>
      </v-layout>
    </v-card-actions>
  </v-card>
</v-container>
  
</template>

<script>
import LocationList from "./LocationList";
import groupService from "../service.js";
import { mapGetters } from "vuex";
const { validationMixin } = require("vuelidate");
const { required, minLength } = require("vuelidate/lib/validators");
export default {
  name: "create-group",
  props: ["dialog"],
  data() {
    return {
      name: null,
      code: null,
      selected: []
    };
  },
  components: {
    LocationList
  },
  computed: {
    ...mapGetters("global", ["currentOrganization"]),
    nameErrors() {
      const errors = [];
      if (!this.$v.name.$dirty) return errors;
      if (!this.$v.name.minLength)
        errors.push(this.$t("validations.nameMushBeAtLeast4CharactersLong"));
      if (!this.$v.name.required) errors.push(this.$t("validations.fieldIsRequired"));
      return errors;
    }
  },
  created() {
    this.getCode();
  },
  methods: {
    selectedLocations(val) {
      this.selected = val;
    },
    close() {
      this.$router.go(-1);
    },
    save() {
      this.$v.$touch();
      if (this.selected.length === 0) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000
          })
          .fire({
            icon: "error",
            title: "Location is not selected"
          });
        return false;
      }
      if (this.$v.$invalid) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000
          })
          .fire({
            icon: "error",
            title: "Invalid Fields"
          });
      } else {
        this.$Progress.start();
        let dataValue = {
          groupName: this.name,
          code: this.code,
          StoreGroupDetail: this.selected,
          organizationID: this.currentOrganization.organizationID
        };
        groupService
          .create(dataValue)
          .then(data => {
            this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000
          })
          .fire({
            icon: "success",
            title: "Group was created"
          });
            this.$Progress.finish();
            this.close();
          })
          .catch(error => {
            console.log("error is :", error);
          });
      }
    },
    randomString(length, chars) {
      let result = "";
      for (var i = length; i > 0; --i) {
        result += chars[Math.floor(Math.random() * chars.length)];
      }
      return result;
    },
    getCode() {
      this.code = this.randomString(10, "0123456789ABCDEFGHIKLMOPQURSTUVWXYZ");
    }
  },
  mixins: [validationMixin],
  validations: {
    name: {
      required,
      minLength: minLength(4)
    }
  }
};
</script>

<style scoped></style>
